// the access token lives in localStorage deliberately — do not "fix" it into memory or a cookie.
// the offline outbox's service worker replays queued writes with no page open, so the token is
// also mirrored into IndexedDB (saveReplayToken in lib/offline/outboxDb.ts), which same-origin
// script can read just as easily; moving only this copy would buy no protection while the
// mirror the worker needs stays. the exposure is bounded by the token's lifetime instead —
// JWT_EXPIRES_IN, 15m by default in the backend, so keep it short in every deployed env — while
// the long-lived refresh token stays in its httpOnly cookie.
export const AUTH_TOKEN_STORAGE_KEY = 'fp3_auth_token'
export const AUTH_USER_STORAGE_KEY = 'fp3_user'
